import { ListerProductData } from '../types';

function initGlobalUtils(eventType: string, data: ListerProductData[]): void {
  if (window?.globalUtils?.load?.length) {
    window.globalUtils.load.forEach((customFunction) => {
      customFunction(eventType, data);
    });
  }
}

export default initGlobalUtils;
